import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DongBoKetoanModal = _resolveComponent("DongBoKetoanModal")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.fetchData }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faRefresh }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Làm mới danh sách ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.isSuperadmin)
            ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSyncModalOpen = true))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: _ctx.faFileImport }, null, 8, ["icon"])
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Đồng bộ từ hệ thống kế toán ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "empty-text": "Chưa có đơn vị nào",
        style: {"width":"100%"},
        size: "medium",
        border: true,
        data: _ctx.filteredItems
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "STT",
            width: "70",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.$index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Mã đơn vị",
            prop: "ma_don_vi",
            "min-width": "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "Tên đơn vị",
            prop: "ten_don_vi",
            "min-width": "220"
          }),
          _createVNode(_component_el_table_column, {
            label: "Cấp",
            width: "90",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatCapDonVi(scope.row.cap_don_vi)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Địa chỉ",
            prop: "dia_chi",
            "min-width": "200"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.dia_chi || "-"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_DongBoKetoanModal, {
        "is-open": _ctx.isSyncModalOpen,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSyncModalOpen = false)),
        onSuccess: _ctx.onSyncSuccess
      }, null, 8, ["is-open", "onSuccess"])
    ]),
    _: 1
  }))
}